// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.source-code {
  font-size: 12px;
  font-weight: bold;
}
.source-code > a {
  color: #213555;
  font-weight: normal;
}
@media (hover: hover) {
  .source-code > a:hover {
    color: rgba(33, 53, 85, 0.7);
  }
}`, "",{"version":3,"sources":["webpack://./src/sections/IntroductionSection/IntroductionSection.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,iBAAA;AADF;AAGE;EACE,cCPS;EDQT,mBAAA;AADJ;AAEI;EACE;IACE,4BAAA;EAAN;AACF","sourcesContent":["@use \"../../utils/themeConstants\";\r\n\r\n.source-code {\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n\r\n  > a {\r\n    color: themeConstants.$color-dark;\r\n    font-weight: normal;\r\n    @media (hover: hover) {\r\n      &:hover {\r\n        color: rgba(themeConstants.$color-dark, 0.7);\r\n      }\r\n    }\r\n  }\r\n}","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
